module.exports = "<table>\n    <thead>\n    <tr>\n        <th>Subtipo</th>\n    </tr>\n    </thead>\n    <tbody *ngIf=\"!list || list.length === 0\">\n    <tr>\n        <td colspan=\"1\">Nenhum {{bemSubtiposModule.single | lowercase}} cadastrado</td>\n    </tr>\n    </tbody>\n    <tbody *ngFor=\"let item of(list | filterActive:showDisabled | sort:['subTipo'])\">\n    <tr [ngClass]=\"{inative: !item.ativo}\">\n        <td>{{item.subTipo}}</td>\n    </tr>\n    </tbody>\n</table>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/bens/bem-subtipos/bem-subtipos-list/bem-subtipos-list.component.html
 ** module id = 929
 ** module chunks = 0
 **/